import type { AdminAccount, ServiceHealthStatus } from '@/types/admin'

export enum ServiceKey {
  AUTH0 = 'auth0',
  SENDGRID = 'sendgrid',
  TWILIO = 'twilio',
  FLEXERA = 'flexera',
  MONGODB = 'mongodb',
  CLEARBLADE = 'clearblade',
  APIGEE = 'apigee',
  GOOGLEMAPS = 'googlemaps',
  GODADDY = 'godaddy'
}

export interface AdminPanelAccountRow {
  email: string
  username: string
  firstName: string
  lastName: string
  accountId: string
  userId: string
  subscription: string
  sapAcctId: string
  lastLogIn: string
}

export interface SetAccountsTableDataPayload {
  accountsData: AdminAccount[]
  simpleSubs: string[]
  loginDates: string[]
}

export interface UpdateServiceStatusPayload {
  key: ServiceKey
  status: ServiceHealthStatus
}

export interface AdminPanelState {
  accounts: AdminPanelAccountRow[]
  serviceStatuses: Record<ServiceKey, ServiceHealthStatus | null>
}

export enum ADMIN_PANEL_MUTATIONS {
  UPDATE_ACCOUNTS_TABLE_DATA = 'updateAccountsTableData',
  UPDATE_SERVICE_STATUS = 'updateServiceStatus'
}

export enum ADMIN_PANEL_ACTIONS {
  SET_ACCOUNTS_TABLE_DATA = 'setAccountsTableData',
  UPDATE_SERVICE_STATUS = 'updateServiceStatus'
}

export enum ADMIN_PANEL_GETTERS {
  GET_ACCOUNTS_TABLE_DATA = 'getAccountsTableData',
  GET_SERVICE_STATUS = 'getServiceStatus'
}
